function getChildSupportFunctionsConfig() {
  const child_support__children_birthdate__value = (values, defaultValue) => {
    return values.children_name?.birthDate
  }

  const child_support__children_budget_received_date__value = (values, defaultValue) => {
    return values.children_approved_date || values.children_birthdate
  }

  const child_support__disbursement_cal__value = (values, defaultValue) => {
    if (values.children_budget_received_date === undefined) {
      return 0
    }
    const childrenBudgetReceivedDate = new Date(values.children_budget_received_date)
    const currentDate = new Date()
    const monthDiff = getMonthDiff(childrenBudgetReceivedDate, currentDate)
    if (monthDiff > 0) {
      return 500 * monthDiff
    } else {
      return 0
    }
  }

  const child_support__disbursement__value = (values, defaultValue) => {
    return values.disbursement_cal || 0
  }

  const child_support__benefits_withdrawn_per_month_from_calculation__value = (values, defaultValue) => {
    return 500
  }

  const child_support__benefits_withdrawn_per_month__value = (values, defaultValue) => {
    return values.benefits_withdrawn_per_month_from_calculation || 0
  }

  const child_support__sum_amount__value = (values, defaultValue) => {
    return (values.disbursement || 0) + (values.benefits_withdrawn_per_month || 0)
  }

  const onlyOneChildForEmployeeSpouse = (context) => {
    return true
  }

  const childrenMustNotMarried = (context) => {
    const { values } = context
    const inputValues = values.inputs
    return !!inputValues?.children_not_married
  }

  const spouseIsGovernmentOfficerOrOtherGovernmentalUnit = (context) => {
    const { values } = context
    const inputValues = values.inputs
    return !!inputValues?.children_got_aid_from_spouse
  }

  function getMonthDiff(date1, date2) {
    const totalMonths1 = date1.getFullYear() * 12 + date1.getMonth()
    const totalMonths2 = date2.getFullYear() * 12 + date2.getMonth()
    const monthDiff = totalMonths2 - totalMonths1
    return monthDiff
  }

  return {
    autoCal: {
      // ...AutoCal,
      child_support__children_birthdate__value,
      child_support__disbursement_cal__value,
      child_support__disbursement__value,
      child_support__benefits_withdrawn_per_month_from_calculation__value,
      child_support__benefits_withdrawn_per_month__value,
      child_support__children_budget_received_date__value,
      child_support__sum_amount__value,
    },
    validate: {
      // ...validate,
      onlyOneChildForEmployeeSpouse,
      childrenMustNotMarried,
      spouseIsGovernmentOfficerOrOtherGovernmentalUnit,
    },
  }
}
